import React from 'react';

const Tag = ({ ...r }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 21" {...r}>
      <path
        fill="#000"
        d="M9.9.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 01-1.414 0l-9.9-9.9a1 1 0 010-1.414L9.9.1zm.707 2.122L2.827 10l8.487 8.485 7.778-7.778-1.06-7.425-7.425-1.06zm2.12 6.364a2 2 0 112.83-2.829 2 2 0 01-2.83 2.829z"
      ></path>
    </svg>
    );
};

export default Tag;
